import * as tslib_1 from "tslib";
import { ChangeDetectorRef, EventEmitter, OnDestroy, ViewContainerRef } from '@angular/core';
import { DataDictionaryApi } from '../../../api/data-dictionary-api';
import { util } from '../../../classes/util';
import { InputConverter } from '../../../inputConverter';
import { FilterService } from '../../../services/filter.service';
import { LayerService } from '../../../services/layer.service';
import { ToSqlStringService } from '../../../services/to-sql-string.service';
import { isQueryableMapCoreLayer } from '../../../types';
import { BaseComponent } from '../../base.component';
var shortWait = 10;
/** Child Records Filter Component */
var ChildRecordsFilterComponent = /** @class */ (function (_super) {
    tslib_1.__extends(ChildRecordsFilterComponent, _super);
    function ChildRecordsFilterComponent(_vcr, changeDetectorRef, layerService, filterService, toSqlStringService, dataDictionaryApi) {
        var _this = _super.call(this, _vcr) || this;
        _this.changeDetectorRef = changeDetectorRef;
        _this.layerService = layerService;
        _this.filterService = filterService;
        _this.toSqlStringService = toSqlStringService;
        _this.dataDictionaryApi = dataDictionaryApi;
        _this.tableColumns = [];
        _this.tableColumnsDisplay = [];
        _this.disableObj = false;
        _this.layerColumns = [];
        _this._summaryItemsString = '';
        _this.selectedChildRecord = null;
        _this._workingQuery = _this.filterService.getEmptyQuery();
        _this.updateLayerOnApply = true;
        _this.finalizeQuery = function () {
            _this.query = _this.filterService.getFinalizedQuery(_this.workingQuery);
        };
        _this.updateQuery = function (query) {
            _this._outsideUpdate = true;
            _this._query = query;
        };
        _this._outsideUpdate = false;
        _this.workingQueryChange = new EventEmitter();
        _this.ondone = new EventEmitter();
        _this.onapply = new EventEmitter();
        _this.activate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.reset();
                        return [4 /*yield*/, this.populateChildRecords()];
                    case 1:
                        _a.sent();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.refreshSubqueries = util.debounce(function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.refreshSubqueriesWork()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); }, shortWait);
        _this.registerEvent('ondone', _this.ondone);
        _this.registerEvent('onapply', _this.onapply);
        _this.registerEvent('workingQueryChange', _this.workingQueryChange);
        _this.setOperatorOptions();
        return _this;
    }
    Object.defineProperty(ChildRecordsFilterComponent.prototype, "layerId", {
        get: function () { return this._layerId; },
        set: function (layerId) {
            this.setLayer(layerId);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChildRecordsFilterComponent.prototype, "query", {
        get: function () {
            return this._query;
        },
        set: function (inputQuery) {
            this._query = inputQuery;
            this.execQuery();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChildRecordsFilterComponent.prototype, "layerRef", {
        get: function () {
            return this._layerRef;
        },
        set: function (value) {
            this._layerRef = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChildRecordsFilterComponent.prototype, "summaryItemsString", {
        get: function () {
            return this._summaryItemsString;
        },
        set: function (inputSummary) {
            this._summaryItemsString = inputSummary;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChildRecordsFilterComponent.prototype, "workingQuery", {
        get: function () {
            return this._workingQuery;
        },
        set: function (inputQuery) {
            this._workingQuery = inputQuery;
        },
        enumerable: true,
        configurable: true
    });
    ChildRecordsFilterComponent.prototype.updateWorkingSql = function (summaryString) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.summaryItemsString = summaryString;
                        return [4 /*yield*/, this.populateWorkingSql()];
                    case 1:
                        _a.sent();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(ChildRecordsFilterComponent.prototype, "andOr", {
        get: function () {
            return this.workingQuery.childTableQuery.operator === 'OR' ? 'or' : 'and';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ChildRecordsFilterComponent.prototype, "showFilter", {
        get: function () {
            return this.layerColumns.length > 0;
        },
        enumerable: true,
        configurable: true
    });
    ChildRecordsFilterComponent.prototype.ngOnDestroy = function () {
        this.reset();
    };
    ChildRecordsFilterComponent.prototype.reset = function () {
        this.selectedChildRecord = null;
        this.childRecords = [];
    };
    ChildRecordsFilterComponent.prototype.execQuery = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.populateLayerDataPromise) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.populateLayerDataPromise];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.refreshSubqueries();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChildRecordsFilterComponent.prototype.populateChildRecords = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, _b;
            var _this = this;
            return tslib_1.__generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        _a = this;
                        return [4 /*yield*/, this.layerService.getLayerChildTableRelationships(this.layerId)];
                    case 1:
                        _a.childRecords = _c.sent();
                        if (!(this.query && this.query.childTableRecord && this.query.childTableRecord.id && this.query.childTableRecord.id > 0)) return [3 /*break*/, 5];
                        if (!(this.childRecords.length === 0 && this.query.childTableRecord.parentLayerId)) return [3 /*break*/, 3];
                        _b = this;
                        return [4 /*yield*/, this.layerService.getLayerChildTableRelationships(Number(this.query.childTableRecord.parentLayerId))];
                    case 2:
                        _b.childRecords = _c.sent();
                        _c.label = 3;
                    case 3:
                        this.selectedChildRecord = this.childRecords.filter(function (x) { return x.id === _this.query.childTableRecord.id; })[0];
                        return [4 /*yield*/, this.populateSelectedChildRecord(this.selectedChildRecord.id)];
                    case 4:
                        _c.sent();
                        _c.label = 5;
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    ChildRecordsFilterComponent.prototype.setLayer = function (layerId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this._layerId = layerId;
                        this.workingSql = '';
                        this.layerRef = undefined;
                        this.table = null;
                        this.layerColumns.length = 0;
                        this.tableColumnsDisplay.length = 0;
                        return [4 /*yield*/, this.populateLayerData()];
                    case 1:
                        _a.sent();
                        this.populateLayerDataPromise = this.populateChildRecords();
                        return [4 /*yield*/, this.populateLayerDataPromise];
                    case 2:
                        _a.sent();
                        this.populateWorkingQueryFromQuery();
                        this.isChildRecordSelected();
                        return [4 /*yield*/, this.refreshSubqueries()];
                    case 3:
                        _a.sent();
                        this.changeDetectorRef.detectChanges();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChildRecordsFilterComponent.prototype.resetSubQueries = function () {
        this.workingQuery.childTableQuery.subqueries = [{ subqueries: [], operator: 'AND' }];
        this.filterService.clearValuesIfNeeded(this.workingQuery.childTableQuery.subqueries);
        this.workingQuery.childTableQuery.subqueries = this.filterService.populateWorkingSubqueryDisplayProperties(this.workingQuery.childTableQuery.subqueries, this.layerColumns);
    };
    ChildRecordsFilterComponent.prototype.remove = function (i) {
        this.workingQuery.childTableQuery.subqueries.splice(i, 1);
        this.refreshSubqueries();
    };
    ChildRecordsFilterComponent.prototype.setAll = function () {
        this.workingQuery.childTableQuery.operator = 'AND';
        this.refreshSubqueries();
    };
    ChildRecordsFilterComponent.prototype.setAny = function () {
        this.workingQuery.childTableQuery.operator = 'OR';
        this.refreshSubqueries();
    };
    ChildRecordsFilterComponent.prototype.setOperatorOptions = function () {
        this.operatorOptions = this.toSqlStringService.getOperatorOptions();
    };
    ChildRecordsFilterComponent.prototype.childRecordChanged = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var tableId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof this.selectedChildRecord === 'string') {
                            this.selectedChildRecord = null;
                        }
                        if (!this.selectedChildRecord) return [3 /*break*/, 2];
                        tableId = this.selectedChildRecord.id;
                        return [4 /*yield*/, this.populateSelectedChildRecord(tableId)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.workingQuery.childTableRecord = this.selectedChildRecord;
                        this.resetSubQueries();
                        //this.workingQuery.childTableQuery = {};
                        return [4 /*yield*/, this.populateWorkingSql()];
                    case 3:
                        //this.workingQuery.childTableQuery = {};
                        _a.sent();
                        this.isChildRecordSelected();
                        this.changeDetectorRef.detectChanges();
                        this.emitWorkingQuery();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChildRecordsFilterComponent.prototype.populateSelectedChildRecord = function (tableId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_1, _a, _b, dataDictionaryColumns, _loop_1, _c, _d, column;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        _b = this;
                        return [4 /*yield*/, this.layerService.getTableColumns(tableId)];
                    case 1:
                        _b.selectedTable = _e.sent();
                        this.tableColumns = this.selectedTable.columns;
                        this.tableColumnsDisplay = this.tableColumns.sort(function (a, b) { return (a.name > b.name) ? 1 : -1; });
                        if (!(this.selectedTable && this.selectedTable.metaTable && this.tableColumns)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.dataDictionaryApi.getColumnsWithDomainValuesByMetaTableId(this.selectedTable.metaTable.id)];
                    case 2:
                        dataDictionaryColumns = _e.sent();
                        if (dataDictionaryColumns) {
                            _loop_1 = function (column) {
                                var matchingColumn = dataDictionaryColumns.find(function (c) { return c.columnName.toLowerCase().trim() === column.name.toLowerCase().trim(); });
                                if (matchingColumn && matchingColumn.domainValues && matchingColumn.domainValues.length) {
                                    column.domainValues = matchingColumn.domainValues;
                                }
                            };
                            try {
                                for (_c = tslib_1.__values(this.tableColumns), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    column = _d.value;
                                    _loop_1(column);
                                }
                            }
                            catch (e_1_1) { e_1 = { error: e_1_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                                }
                                finally { if (e_1) throw e_1.error; }
                            }
                        }
                        _e.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ChildRecordsFilterComponent.prototype.applyFilterChangeToLayer = function () {
        this.ondone.emit({ layerId: this.layerId, tableId: this.selectedTable.id, sql: this.workingSql, query: this.query });
    };
    ChildRecordsFilterComponent.prototype.addBottomSubqueryIfNeeded = function () {
        if (this.workingQuery.childTableQuery.subqueries) {
            var addWorkingSubquery = this.workingQuery.childTableQuery.subqueries.length === 0;
            if (!addWorkingSubquery) {
                var lastSubquery = this.workingQuery.childTableQuery.subqueries[this.workingQuery.childTableQuery.subqueries.length - 1];
                addWorkingSubquery = this.toSqlStringService.queryConditionIsValid(lastSubquery);
            }
            if (addWorkingSubquery) {
                this.workingQuery.childTableQuery.subqueries.push({ field: '', operator: '=', value: null });
            }
        }
    };
    ChildRecordsFilterComponent.prototype.populateLayerData = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, e_2, _b, layers, tables, _c, _d, layerColumn;
            return tslib_1.__generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!this.layerId) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.filterService.getLayerData(this.layerId)];
                    case 1:
                        layers = _e.sent();
                        if (layers.length > 0) {
                            this.layerRef = layers[0];
                            tables = this.layerRef.tables;
                            this.table = tables.sort(function (a, b) { return a.geometryType.localeCompare(b.geometryType); })[0];
                            if (this.layerRef.queryJSON) {
                                this.layerQuery = JSON.parse(this.layerRef.queryJSON);
                            }
                            else {
                                this.layerQuery = {};
                            }
                            this.layerColumns.length = 0;
                            (_a = this.layerColumns).push.apply(_a, tslib_1.__spread(layers[0].columns));
                            try {
                                for (_c = tslib_1.__values(this.layerColumns), _d = _c.next(); !_d.done; _d = _c.next()) {
                                    layerColumn = _d.value;
                                    layerColumn.name = layerColumn.name.toLowerCase();
                                }
                            }
                            catch (e_2_1) { e_2 = { error: e_2_1 }; }
                            finally {
                                try {
                                    if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
                                }
                                finally { if (e_2) throw e_2.error; }
                            }
                            return [2 /*return*/, this.layerColumns];
                        }
                        _e.label = 2;
                    case 2: return [2 /*return*/, []];
                }
            });
        });
    };
    ChildRecordsFilterComponent.prototype.populateWorkingQueryFromQuery = function () {
        if (this.query) {
            this.workingQuery = this.filterService.populateWorkingQueryFromQuery(this.query, this.tableColumns);
        }
    };
    ChildRecordsFilterComponent.prototype.populateWorkingSql = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.table) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.filterService.populateWorkingSql(this.layerQuery, this.workingQuery, this.table, this.layerColumns)];
                    case 1:
                        _a.workingSql = _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ChildRecordsFilterComponent.prototype.refreshSubqueriesWork = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var populatePromises_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filterService.clearValuesIfNeeded(this.workingQuery.childTableQuery.subqueries);
                        this.workingQuery.childTableQuery.subqueries = this.filterService.populateWorkingSubqueryDisplayProperties(this.workingQuery.childTableQuery.subqueries, this.layerColumns);
                        return [4 /*yield*/, this.populateWorkingSql()];
                    case 1:
                        _a.sent();
                        if (!(this.selectedChildRecord && this.workingQuery.childTableQuery.subqueries && this.workingQuery.childTableQuery.subqueries.length)) return [3 /*break*/, 3];
                        populatePromises_1 = [];
                        this.workingQuery.childTableQuery.subqueries.forEach(function (sq, i) {
                            if (!sq.distinctValues) {
                                populatePromises_1.push(_this.filterService.populateDistinctValues(_this.selectedChildRecord.id, sq, (_this.layerQuery && _this.layerQuery.childTableQuery) ? _this.layerQuery.childTableQuery : {}, _this.workingQuery.childTableQuery, _this.tableColumns, i, true, _this.esriLayers && _this.esriLayers.length ? _this.esriLayers[0].mapcoreProps.isPETL : null));
                            }
                        });
                        return [4 /*yield*/, Promise.all(populatePromises_1)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.addBottomSubqueryIfNeeded();
                        this.changeDetectorRef.detectChanges();
                        this.showSelectMenu();
                        this.emitWorkingQuery();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChildRecordsFilterComponent.prototype.toggleShowSql = function () {
        this.showSQL = !this.showSQL;
    };
    ChildRecordsFilterComponent.prototype.emitWorkingQuery = function () {
        if (!this._outsideUpdate) {
            this.workingQueryChange.emit({ workingQuery: this.workingQuery, childColumns: this.tableColumns });
        }
        this._outsideUpdate = false;
        this.changeDetectorRef.detectChanges();
    };
    ChildRecordsFilterComponent.prototype.showSelectMenu = function () {
        var addWorkingSubquery = false;
        if (this.workingQuery && this.workingQuery.childTableQuery && this.workingQuery.childTableQuery.subqueries) {
            addWorkingSubquery = this.workingQuery.childTableQuery.subqueries.length === 0;
            if (!addWorkingSubquery) {
                var lastSubquery = this.workingQuery.childTableQuery.subqueries[0];
                addWorkingSubquery = this.toSqlStringService.queryConditionIsValid(lastSubquery);
            }
        }
        this.disableSelectMenu = addWorkingSubquery;
    };
    ChildRecordsFilterComponent.prototype.layerData = function (layerRef) {
        var mcWindow = document.getElementById('mcWindow');
        var titleText = 'Filter';
        if (layerRef) {
            titleText = "Filter: " + layerRef.name;
        }
        mcWindow.title = titleText;
    };
    ChildRecordsFilterComponent.prototype.onValueChange = function (_event) {
        var _this = this;
        this.changeDetectorRef.detectChanges();
        setTimeout(function () { _this.refreshSubqueries(); }, shortWait);
    };
    ChildRecordsFilterComponent.prototype.onFieldChange = function (field, subquery, subqueryIndex) {
        subquery.field = field;
        this.selectedFilterColumn(subquery, subqueryIndex);
    };
    ChildRecordsFilterComponent.prototype.selectedFilterColumn = function (subquery, subqueryIndex) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        subquery.multiValue = null;
                        subquery.value = null;
                        this.changeDetectorRef.detectChanges();
                        return [4 /*yield*/, this.filterService.populateDistinctValues(this.selectedChildRecord.id, subquery, this.layerQuery, this.workingQuery.childTableQuery, this.tableColumns, subqueryIndex, true, this.esriLayers && this.esriLayers.length ? this.esriLayers[0].mapcoreProps.isPETL : null)];
                    case 1:
                        subquery = _a.sent();
                        this.refreshSubqueries();
                        return [2 /*return*/];
                }
            });
        });
    };
    ChildRecordsFilterComponent.prototype.applyFilter = function () {
        this.finalizeQuery();
        var data = {
            layerId: this.layerId,
            tableId: this.selectedTable.id,
            sql: this.workingSql,
            query: this.query,
            childColumns: null
        };
        this.ondone.emit(data);
        if (this.updateLayerOnApply) {
            data.childColumns = this.tableColumns;
            this.onapply.emit({ id: data.layerId.toString(), data: data });
            var esriLayer = this.layerService.getEsriLayerByUniqueId(this.esriLayerId);
            if (esriLayer && data && isQueryableMapCoreLayer(esriLayer)) {
                esriLayer.mapcoreProps.filter = data.sql;
                esriLayer.mapcoreProps.query = data.query;
                esriLayer.mapcoreProps.childColumns = data.childColumns;
                this.layerService.updateLayerFilter(esriLayer, data.query);
                this.onapply.emit({ esriLayer: esriLayer });
            }
            else {
                this.onapply.emit(null);
            }
        }
    };
    ChildRecordsFilterComponent.prototype.cancel = function () {
        this.ondone.emit(null);
    };
    ChildRecordsFilterComponent.prototype.isChildRecordSelected = function () {
        this.disableObj = (typeof this.selectedChildRecord === 'string') || this.selectedChildRecord === null || this.selectedChildRecord === undefined;
    };
    ChildRecordsFilterComponent.prototype.setFilter = function (layerId, esriLayerId, layerColumns, query) {
        this._layerId = layerId;
        this.esriLayerId = esriLayerId;
        this.layerColumns = layerColumns;
        this._query = query;
        this._outsideUpdate = true;
        this.setLayer(layerId);
    };
    tslib_1.__decorate([
        InputConverter(),
        tslib_1.__metadata("design:type", Boolean)
    ], ChildRecordsFilterComponent.prototype, "updateLayerOnApply", void 0);
    return ChildRecordsFilterComponent;
}(BaseComponent));
export { ChildRecordsFilterComponent };
